import {Alert, Button, Form, Input} from 'antd';
import {SaveOutlined, DeleteOutlined} from "@ant-design/icons";
import {useCallback, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {getSnapshotVersion, patchSnapshotVersion} from "../../services/snapshot_version";
import { toast } from 'sonner';

export default function VersionEdit() {
    const {id, snapshot} = useParams();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!snapshot)
            return;

        setLoading(true);
        getSnapshotVersion(snapshot).then(({data}) => {
            form.setFieldsValue(data)
            setLoading(false)
        }).catch((e) => {
            console.error(e)
            toast.error("Falha ao carregar informações do chatbot");
        })
    }, [snapshot, form])

    const save = useCallback((values) => {
        setSaving(true)
        patchSnapshotVersion(snapshot, values).then(() => {
            setSaving(false)
            navigate(`/chatbots/${id}/versions/`);
            toast.success("Chatbot salvo com sucesso!");
        }).catch(e => {
            console.error(e)
            setSaving(false);
            toast.error("Falha ao salvar informações do chatbot");
        })
    }, [snapshot, id])

    return (
        <Form
            name="basic"
            style={{
                maxWidth: 600,
            }}
            layout={'vertical'}
            disabled={loading}
            autoComplete="off"
            form={form}
            onFinish={save}
        >


            <Form.Item
                label="Versão"
                name="version"
                rules={[
                    {
                        required: true,
                        message: 'Esta versão deve ter um nome',
                    },
                ]}
            >
                <Input/>
            </Form.Item>
            <Alert
                message="Atenção"
                description="Aqui não será possível configurar intenções, entidades ou fluxo. Para isso utilize nosso app na página anterior clicando no título da versão.s"
                type="info"
                showIcon/>
            <br/>
            <Form.Item>
                <Button loading={saving} icon={<SaveOutlined/>} type="primary" htmlType="submit">
                    Salvar
                </Button>
                <Button danger style={{marginLeft: '1rem'}} htmlType="button" icon={<DeleteOutlined/>}>
                    Deletar
                </Button>
            </Form.Item>
        </Form>
    )
}
